export const projects = [
  {
    slug: "bvv",
    title: "BVV Sachsen",
    category: "IT Administration & Beratung",
    teaser: "Stabile Infrastruktur für den Beratungsalltag inklusive DSGVO-fähiger Cloud.",
    body: "Seit 2021 begleite ich die BVV Sachsen bei Hardware-Entscheidungen, Client-Setup, Netzwerk und einem robusten Cloud-Workflow für die tägliche Kundenarbeit.",
    image: "/static/images/consulting.webp",
    links: [
      {
        label: "Mehr zu BVV",
        href: "https://www.bvv-sachsen.de"
      }
    ]
  },
  {
    slug: "inpott",
    title: "inpott UG",
    category: "Migration & Cloud",
    teaser: "Hosting- und Mailmigration mit sauberer Integration in das Apple-Ökosystem.",
    body: "Die gesamte Web- und Mailumgebung wurde auf ein neues Setup migriert. Parallel wurde die iCloud-basierte Fotoablage so integriert, dass Team und Marketing jederzeit sicher zugreifen können.",
    image: "/static/images/inpott_project.webp",
    links: []
  },
  {
    slug: "landingpage",
    title: "Digitale Hochzeitseinladung",
    category: "Webdesign",
    teaser: "Mobile Landingpage mit Ablauf, Maps, Speisekarte und Fotozugang per QR-Code.",
    body: "Die Einladung wurde als zentrale Informationsseite umgesetzt. Änderungen konnten kurzfristig eingepflegt werden, während Gäste Treffpunkt und Updates jederzeit mobil abrufen konnten.",
    image: "/static/images/landingpage_project.webp",
    links: []
  },
  {
    slug: "smarthome",
    title: "Home Assistant Integration",
    category: "Smarthome & Automatisierung",
    teaser: "Herstellerübergreifende Steuerung für Licht und Heizung auf einer Oberfläche.",
    body: "Unterschiedliche Geräte wurden in einem einheitlichen Home-Assistant-Setup gebündelt. Ergebnis: Steuerung per App, Sprache und Automationen ohne App-Chaos.",
    image: "/static/images/smarthome_project.webp",
    links: []
  }
];

export const projectMap = projects.reduce((accumulator, project) => {
  accumulator[project.slug] = project;
  return accumulator;
}, {});
